/* eslint-disable react-hooks/rules-of-hooks */
import { t } from "i18next";
import { Tag } from "antd";
import { AccountActionMenu } from "./ActionAccountMenu";
import { useMemo } from "react";
import { formatDateTime } from "utils/dateTime";
import { MenuLayout } from "components/CustomFilterMenu/MenuLayout";
import { Checkbox } from "antd";

export const useAccountLoginList = ({
  onEdit,
  onResetPassword,
  onLock,
  onUnlock,
  onDisable,
  statusFilter,
  setStatusFilter,
  tempStatusFilter,
  setTempStatusFilter,
  setFilterDropdownVisible,
  canUpdate,
  canResetPassword,
  canLock,
  canDelete,
}) => {
  const statusOptions = [
    { label: "Chưa kích hoạt", value: "PENDING" },
    { label: "Đang hoạt động", value: "ACTIVE" },
    { label: "Tạm dừng hoạt động", value: "DISABLED" },
    { label: "Vô hiệu hoá", value: "DELETED" },
  ];

  const handleVisibleChange = (visible) => {
    setFilterDropdownVisible(visible);
    if (visible) {
      setTempStatusFilter(statusFilter);
    }
  };

  const columns = useMemo(
    () => [
      {
        title: t("common.index"),
        align: "center",
        render: (_, record, index) => index + 1,
      },
      {
        title: t("seller.loginAccount"),
        align: "center",
        render: (_, record, index) => {
          return record?.email || "- -";
        },
      },
      {
        title: t("seller.name_account"),
        align: "center",
        render: (_, record, index) => {
          return record?.fullname || "- -";
        },
      },
      //UI mới không hiện thị số điện thoại
      // {
      //   align: "center",
      //   title: t("cart.telephone"),
      //   render: (_, record, index) => {
      //     return record?.telephone || "- -";
      //   },
      // },
      {
        align: "center",
        title: t("cart.account_user_seller_type"),
        dataIndex: "level",
        render: (_, record) => {
          const typeMap = {
            MANAGER: "Quản lý",
            STAFF: "Nhân viên",
          };

          return typeMap[record?.accountUserSellerType] || "- -";
        },
      },
      {
        title: t("cart.count_order"),
        align: "center",
        width: 120,
        onHeaderCell: () => ({
          style: {
            whiteSpace: "nowrap",
          },
        }),
        render: (_, record) => {
          return <span style={{ whiteSpace: "nowrap" }}>{record?.totalOrderByUser || 0}</span>;
        },
      },
      {
        align: "center",
        width: 160,
        filterDropdown: (
          <MenuLayout
            style={{ width: 300 }}
            filterContent={
              <Checkbox.Group options={statusOptions} value={tempStatusFilter} onChange={setTempStatusFilter} />
            }
            resetFilter={() => setStatusFilter([])}
            applyFilter={() => {
              setStatusFilter(tempStatusFilter);
              setFilterDropdownVisible(false);
            }}
          />
        ),
        title: t("cart.account_user_seller_status"),
        dataIndex: "level",
        render: (_, record) => {
          const baseStyle = {
            borderRadius: 25,
            padding: "6px 16px",
            fontWeight: 500,
          };

          const statusMap = {
            PENDING: {
              text: "Chưa kích hoạt",
              style: { background: "#FBE3BAB2", border: "1px solid #FF7F00", color: "#FF7F00" },
            },
            ACTIVE: {
              text: "Đang hoạt động",
              style: { background: "#d2f5dbff", border: "1px solid #00AB78", color: "#00AB78" },
            },
            DISABLED: {
              text: "Tạm dừng hoạt động",
              style: { background: "#FFF7ED", border: "1px solid #FB923C", color: "#C2410C" },
            },
            DELETED: {
              text: "Vô hiệu hoá",
              style: { background: "#F3F3F7", border: "1px solid #AFBBCA", color: "#AFBBCA" },
            },
          };

          const key =
            record?.status === "DISABLED" || record?.status === "DELETED"
              ? record?.status
              : record.needChangePassword
                ? "PENDING"
                : record?.status;
          const s = statusMap[key];

          return s ? <Tag style={{ ...baseStyle, ...s.style }}>{s.text}</Tag> : <Tag style={baseStyle}>- -</Tag>;
        },
      },
      {
        align: "center",
        title: t("cart.date_create_seller"),
        dataIndex: "level",
        width: 80,
        sorter: (a, b) => new Date(a.createdAt || 0) - new Date(b.createdAt || 0),
        onHeaderCell: () => ({
          style: {
            whiteSpace: "nowrap",
          },
        }),
        render: (_, record) => {
          if (!record?.createdAt) return "-";
          return (
            <div style={{ lineHeight: 1.2 }}>
              <div>{formatDateTime(record.createdAt)}</div>
            </div>
          );
        },
      },
      {
        title: t("cart.action"),
        width: 140,
        align: "center",
        render: (_, record) => (
          <AccountActionMenu
            record={record}
            onEdit={onEdit}
            onResetPassword={onResetPassword}
            onLock={onLock}
            onUnlock={onUnlock}
            onDisable={onDisable}
            canUpdate={canUpdate}
            canResetPassword={canResetPassword}
            canLock={canLock}
            canDelete={canDelete}
          />
        ),
      },
    ],
    [onEdit, onResetPassword, onLock, onUnlock, onDisable, canUpdate, canResetPassword, canLock, canDelete]
  );
  return {
    columns,
  };
};
